import PointService from "@/services/PointService.js";

export default {
  namespaced: true,
  state: {
    balance: 0,
    loading: false,
    errors: null
  },
  getters: {
    pointsWithCommas: state => {
      return state.balance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  mutations: {
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_BALANCE(state, balance) {
      state.balance = balance;
    },
    SET_ERRORS(state, errors) {
      state.errors = errors;
    },
    RESET_ERRORS(state) {
      state.errors = null;
    }
  },
  actions: {
    async resetErrors({ commit }) {
      commit("RESET_ERRORS");
    },
    getCustomerBalance: async ({ commit }, request) => {
      commit("SET_LOADING", true);
      try {
        let response = await PointService.getCustomerBalance(request);
        commit("SET_BALANCE", response.balance);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      }
    }
  }
};
